import axios from 'axios'

class EtapaServicoService {
  async getAll(params = {}) {
    const { data } = await axios.get('api/v1/patio/etapas-servico/', { params })
    return data
  }

  async getByServico(servicoId) {
    const { data } = await axios.get(`api/v1/patio/servicos/${servicoId}/etapas/`)
    return data
  }

  async get(id) {
    const { data } = await axios.get(`api/v1/patio/etapa-servico/${id}/`)
    return data
  }
}

export default new EtapaServicoService()